import fetchSearchResults, { SOCKET_SEARCH_RESULTS_MESSAGE } from '../actions/search-socket';
import { SOCKET_TYPING_MESSAGE, addTypingUser, removeTypingUserDebounced } from '../actions/typing-socket';
import { SOCKET_NEW_COMMENT, newComment } from '../actions/comment-socket';
import {
  SOCKET_NEW_POST,
  SOCKET_UPDATE_POST_COUNTERS,
  SOCKET_UPDATE_CATEGORY_COUNTERS,
  newPost,
  updatePostCounters,
  updateCategoryCounters,
} from '../actions/category-socket';
import { SOCKET_UPDATE_POST, updatePost } from '../actions/post-socket';
import {
  SOCKET_NEW_NOTIFICATION,
  newNotification,
  SOCKET_USER_PERMISSIONS_CHANGED,
  setUserPermissions,
  SOCKET_USER_UPDATED,
} from '../actions/user-socket';
import { setCurrentUser } from '../actions/set-current-user';

const channels = {};
const socketActionCreators = {};

const getPayload = cb => {
  return msg => cb(msg.payload);
};

socketActionCreators[SOCKET_SEARCH_RESULTS_MESSAGE] = getPayload(fetchSearchResults);
socketActionCreators[SOCKET_TYPING_MESSAGE] = message => dispatch => {
  dispatch(getPayload(removeTypingUserDebounced)(message));
  dispatch(getPayload(addTypingUser)(message));
};
socketActionCreators[SOCKET_NEW_COMMENT] = getPayload(newComment);
socketActionCreators[SOCKET_NEW_POST] = getPayload(newPost);
socketActionCreators[SOCKET_UPDATE_POST_COUNTERS] = getPayload(updatePostCounters);
socketActionCreators[SOCKET_UPDATE_CATEGORY_COUNTERS] = getPayload(updateCategoryCounters);
socketActionCreators[SOCKET_UPDATE_POST] = getPayload(updatePost);
socketActionCreators[SOCKET_NEW_NOTIFICATION] = getPayload(newNotification);
socketActionCreators[SOCKET_USER_PERMISSIONS_CHANGED] = getPayload(setUserPermissions);
socketActionCreators[SOCKET_USER_UPDATED] = getPayload(setCurrentUser);

export default function wsMiddleware(wsClient, instanceId) {
  const channelPrefix = `instance-${instanceId}/`;
  return store => next => action => {
    const payload = {};

    switch (action.type) {
      case 'WS_JOIN':
        payload.channel = action.payload.channel;
        if (action.payload.channel.indexOf('user-') === -1) {
          payload.channel = `${channelPrefix}${action.payload.channel}`;
        }
        wsClient.queue('join', payload);
        channels[payload.channel] = wsClient.createListener(payload.channel);
        Object.keys(socketActionCreators).forEach(event => {
          channels[payload.channel].on(event, data => {
            store.dispatch(socketActionCreators[event](data));
          });
        });
        break;
      case 'WS_LEAVE':
        payload.channel = `${channelPrefix}${action.payload.channel}`;
        if (channels[payload.channel]) {
          channels[payload.channel].destroy();
          delete channels[payload.channel];
        }
        break;
      case 'WS_EMIT':
        payload.channel = `${channelPrefix}${action.payload.channel}`;
        payload.eventName = action.payload.eventName;
        payload.payload = action.payload.message;
        wsClient.queue('emit', payload);
        break;

      default:
        return next(action);
    }
  };
}



// WEBPACK FOOTER //
// ./app/middleware/create-websocket-middleware.js